import { useNavigate } from "react-router-dom";
import defaultAvatar from "../../../assets/sampleAvatar.png";

export default function SuggestionCard({ avatar, username, user_id }) {
  const navigate = useNavigate();

  function navigateToSearchedPerson() {
    return navigate(`/profile?username=${username}`, {
      state: { suggestedUser_id: user_id },
    });
  }

  return (
    <div
      id="suggestionCard"
      className="rounded-4 d-flex flex-column"
      style={{
        border: "1px solid var(--main-purple)",
        maxWidth: "10rem",
        maxHeight: "20rem",
      }}
    >
      <div onClick={navigateToSearchedPerson}>
        {/* AVATAR OF PERSON */}
        <div className="mb-3 rounded-ircle" style={{ padding: ".5rem" }}>
          <img
            src={avatar && avatar !== "sampleAvatar.png" ? avatar : defaultAvatar}
            alt="Avatar of Person"
            className="w-100 rounded-circle"
          />
        </div>

        {/* PERSON'S USERNAME */}
        <div className="d-flex align-items-center justify-content-center mb-3">
          <span style={{ fontSize: "1.2rem", color: "var(--main-purple)" }}>
            {username}
          </span>
        </div>
      </div>

      {/* BUTTON TO CONNECT */}
      <button
        className="connect-btn w-100 rounded-4 p-3"
        style={{
          fontSize: "1.2rem",
          backgroundColor: "var(--main-purple)",
        }}
      >
        Connect
      </button>
    </div>
  );
}
